var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 w-full h-full overflow-scroll scrolling-touch"},[_c('MDArea',{staticClass:"lg:max-w-2xl",attrs:{"md":require('raw-loader!../MDs/friends.md').default}}),_c('div',{staticClass:"h-64"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }